// extracted by mini-css-extract-plugin
export var container = "styles-module--container--tHXiz";
export var imgMain = "styles-module--imgMain--TBSAG";
export var label1 = "styles-module--label1--0HZD7";
export var label2 = "styles-module--label2--sbtgC";
export var titleContainer = "styles-module--titleContainer--x7o-a";
export var contentWrapper = "styles-module--contentWrapper--PYs-h";
export var signupButton = "styles-module--signupButton--QxHN-";